import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { allProjects } from '../../mocks/projects';

export default function PortfolioPage() {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero */}
      <section className="relative h-[55vh] w-full overflow-hidden">
        <img
          src="https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/21dfa1ef13c164aaf1f64f7ef87ccc37.jpeg"
          alt="Reiken Portfolio"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 sm:px-8 md:px-20 w-full">
          <p className="text-white/60 text-xs uppercase tracking-[0.35em] mb-5 font-light">Our Work</p>
          <h1 className="text-white text-5xl sm:text-6xl md:text-8xl font-bold leading-tight">
            Project<br />
            <span className="italic font-light">Portfolio</span>
          </h1>
          <div className="w-12 h-px bg-white/40 mt-8" />
        </div>
      </section>

      <main className="py-20 sm:py-28 px-6 sm:px-8 md:px-20">
        <div className="max-w-7xl mx-auto">

          <div className="mb-14">
            <p className="text-black/50 text-base leading-relaxed font-light max-w-xl">
              From luxury flagship stores to shop-in-shop installations for the world's most prestigious brands — every project reflects our commitment to excellence.
            </p>
          </div>

          {/* Grid — responsive: 1 col mobile, 2 col tablet, 3 col desktop */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-black/10">
            {allProjects.map((project, index) => (
              <Link
                key={project.id}
                to={`/portfolio/${project.slug}`}
                className="group relative block overflow-hidden aspect-[4/3] sm:aspect-square bg-white cursor-pointer"
                onMouseEnter={() => setHoveredId(project.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-108"
                  style={{ transform: hoveredId === project.id ? 'scale(1.08)' : 'scale(1)' }}
                  loading="lazy"
                />

                {/* Always-visible bottom label */}
                <div className={`absolute bottom-0 left-0 right-0 px-6 py-5 bg-gradient-to-t from-black/75 via-black/30 to-transparent transition-opacity duration-400 ${hoveredId === project.id ? 'opacity-0' : 'opacity-100'}`}>
                  <p className="text-white/55 text-[9px] uppercase tracking-[0.3em] mb-1 font-light">
                    {project.category ?? 'Retail Design'}
                  </p>
                  <h3 className="text-white text-sm font-semibold leading-snug">{project.title}</h3>
                </div>

                {/* Hover overlay */}
                <div className={`absolute inset-0 bg-black/60 flex flex-col items-center justify-center transition-opacity duration-400 ${hoveredId === project.id ? 'opacity-100' : 'opacity-0'}`}>
                  <span className="text-white/50 text-[9px] uppercase tracking-[0.4em] mb-3 font-light">View Project</span>
                  <h3 className="text-white text-base font-bold text-center px-10 leading-snug">{project.title}</h3>
                  <div className="mt-5 w-6 h-px bg-white/60" />
                  <div className="mt-5 w-8 h-8 rounded-full border border-white/40 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-white text-sm" />
                  </div>
                </div>

                {/* Index number */}
                <div className="absolute top-4 right-4 text-white/20 text-xs font-light tabular-nums">
                  {String(index + 1).padStart(2, '0')}
                </div>
              </Link>
            ))}
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}
